import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
export const dateAdapter = AdapterDayjs;
